import { render, staticRenderFns } from "./new_add.vue?vue&type=template&id=36cebf3d&scoped=true&"
import script from "./new_add.vue?vue&type=script&lang=js&"
export * from "./new_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cebf3d",
  null
  
)

export default component.exports